/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Settings_Set_SoundsInputs */

const en_us2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sound on each set and record`)
};

const pt_br2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Som ao registrar série e recorde`)
};

const es_419_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonido al registrar series y récords`)
};

const pt_pt2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Som ao registar série e recorde`)
};

const fr_fr2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son à chaque série et record`)
};

const de_de2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton bei jedem Satz und Rekord`)
};

const it_it2_workout_live_settings_set_sounds = /** @type {(inputs: Workout_Live_Settings_Set_SoundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suono a ogni serie e record`)
};

/**
* | output |
* | --- |
* | "Sound on each set and record" |
*
* @param {Workout_Live_Settings_Set_SoundsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_settings_set_sounds = /** @type {((inputs?: Workout_Live_Settings_Set_SoundsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Settings_Set_SoundsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_settings_set_sounds(inputs)
	if (locale === "es-419") return es_419_workout_live_settings_set_sounds(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_settings_set_sounds(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_settings_set_sounds(inputs)
	if (locale === "de-DE") return de_de2_workout_live_settings_set_sounds(inputs)
	if (locale === "it-IT") return it_it2_workout_live_settings_set_sounds(inputs)
	return en_us2_workout_live_settings_set_sounds(inputs)
});
export { workout_live_settings_set_sounds as "workout-live.settings_set_sounds" }